import React from 'react';
import { FaFileSignature, FaHome, FaGlobeAmericas, FaUniversity } from 'react-icons/fa';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaFileSignature />,
      title: 'General Notary Services',
      description: 'Notarization of signatures on various documents including affidavits, contracts, and more.'
    },
    {
      icon: <FaHome />,
      title: 'Real Estate Documents',
      description: 'Notarization of deeds, mortgages, refinancing documents, and other real estate paperwork.'
    },
    {
      icon: <FaGlobeAmericas />,
      title: 'Online Notarization',
      description: 'Secure remote online notarization services available from anywhere in Washington.'
    },
    {
      icon: <FaUniversity />,
      title: 'Legal Documents',
      description: 'Notarization of power of attorney, wills, trusts, and other legal documents.'
    }
  ];

  return (
    <section className="section services-section">
      <div className="container">
        <h2 className="section-title">Our Notary Services</h2>
        <p className="section-subtitle">
          Professional notarization services tailored to meet your specific needs
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;